
import { defineComponent } from 'vue'
import TeamContent from '../components/TeamContent.vue'

export default defineComponent({
  name: 'TeamView',
  components: { TeamContent }
})
